import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CerrixSelectComponent } from "@app/shared/atoms/cerrix-select/cerrix-select.component";

@Component({
    selector: "app-cerrix-show-total-items",
    imports: [CerrixSelectComponent],
    templateUrl: "./cerrix-show-total-items.component.html",
    styleUrl: "./cerrix-show-total-items.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixShowTotalItemsComponent {
    @Input() itemsText: string = "items";
    @Input() dropdownOptions: { label: string; value: string }[] = [];
    @Input() dropdownPlaceholder: string = "";
    @Input() dropdownSelectedIndex: number = -1;

    @Output() dropdownSelectionChange = new EventEmitter<string>();
}
